import Parse from "../../api/ApiConfig";

/**********************
	API functions
**********************/
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

export const getAllCustomers = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getUsers`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getCustomerInfo = async(userId)=>{
    let requestBody = { id: userId };

	try {
		const response = await fetch(
			`${Parse.serverURL}/functions/getUserById`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
}

export const handleCustomerDeletion = async(userId)=>{
    let requestBody = { userIds: userId };

	try {
		const response = await fetch(
			`${Parse.serverURL}/functions/deleteCustomers`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
}


export const getTransactionHistory = async(userId)=>{
	let requestBody = { userId: userId };

	try{
		const response = await fetch(
			`${Parse.serverURL}/functions/getTransactions`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	}
	catch(error){
		return error;
	}
}



export const getInvestments = async(userId)=>{
	let requestBody = { userId: userId };

	try{
		const response = await fetch(
			`${Parse.serverURL}/functions/getInvestments`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	}
	catch(error){
		return error;
	}

}

export const getUpcomingPayments = async (userId) => {
	let requestBody = { userId: userId };

	try{
		const response = await fetch(
			`${Parse.serverURL}/functions/upcomingPayments`,
			{
				method: "POST",
				headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
				body: JSON.stringify(requestBody),
			}
		);
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	}
	catch(error){
		return error;
	}
	
};


export const fetchChartData = async () => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getUsersAnalysis";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			console.log(res)
			return res;
		}
	} catch (error) {
		return error;
	}
};
